import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { SemesterService } from "../report-services/semester.service";
import { TeacherPersonService } from "../report-services/teacher-person.service";
import { DayService } from "../report-services/day.service";
import { PeriodService } from "../report-services/period.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./markroster.component.html",
})
export class MarkRosterComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private periodService: PeriodService,
		private dayService: DayService,
		private teacherpersonService: TeacherPersonService,
		private semesterService: SemesterService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		SemesterID: 0,
		InstructorID: 0,
		DayID: 0,
		PeriodID: 0,
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	SemesterList: any = [];
	TeacherPersonList: any = [];
	DayList: any = [];
	PeriodList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 369;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadSemesterList()
		// this.loadTeacherPersonList()
		// this.loadDayList()
		// this.loadPeriodList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadSemesterList();
		this.loadTeacherPersonList();
		this.loadDayList();
		this.loadPeriodList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(369);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadSemesterList() {
		this.report.SemesterID = 0;
		var result = this.semesterService.loadSemesterList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterList = response;

				if (this.SemesterList.length > 1) {
					// this.SemesterList.unshift({
					//     SemesterID: 0,
					//     SemesterDesc: "All Semesters"
					// })
					this.report.SemesterID = this.SemesterList[0].SemesterID;
				} else {
					this.report.SemesterID = this.SemesterList[0].SemesterID;
				}
			},
			(error) => {}
		);
	}

	private loadTeacherPersonList() {
		this.report.InstructorID = 0;
		var result = this.teacherpersonService.loadTeacherPersonList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.TeacherPersonList = response;

				if (this.TeacherPersonList.length > 1) {
					// this.TeacherPersonList.unshift({
					//     TeacherPersonID: 0,
					//     TeacherPersonDesc: "All TeacherPersons"
					// })
					this.report.InstructorID = this.TeacherPersonList[0].Teacher_PersonID;
				} else {
					this.report.InstructorID = this.TeacherPersonList[0].Teacher_PersonID;
				}
			},
			(error) => {}
		);
	}

	private loadDayList() {
		this.report.DayID = 0;
		var result = this.dayService.loadDayList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DayList = response;

				if (this.DayList.length > 1) {
					// this.DayList.unshift({
					//     DayID: 0,
					//     DayDesc: "All Days"
					// })
				} else {
					this.report.DayID = this.DayList[0].DayID;
				}
			},
			(error) => {}
		);
	}

	private loadPeriodList() {
		this.report.PeriodID = 0;
		var result = this.periodService.loadPeriodList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PeriodList = response;

				if (this.PeriodList.length > 1) {
					this.PeriodList.unshift({
						PeriodID: 0,
						PeriodDesc: "All Periods",
					});
				} else {
					this.report.PeriodID = this.PeriodList[0].PeriodID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// //Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.SemesterID) {
		// 	this.errorMessage = "Select the Semester"
		// 	return;
		// }

		// if (!this.report.InstructorID) {
		// 	this.errorMessage = "Select the TeacherPerson"
		// 	return;
		// }

		// if (!this.report.DayID) {
		// 	this.errorMessage = "Select the Day"
		// 	return;
		// }

		// if (!this.report.PeriodID) {
		// 	this.errorMessage = "Select the Period"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 369;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: SemesterID
		strParam += "," + this.report.SemesterID + "|SemesterID";

		//Parameter 3: TeacherPersonID
		strParam += "," + this.report.InstructorID + "|TeacherPersonID";

		//Parameter 4: DayID
		strParam += "," + this.report.DayID + "|DayID";

		//Parameter 5: PeriodID
		strParam += "," + this.report.PeriodID + "|PeriodID";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
